import React from 'react'

const StripePaymentSuccessPage = () => {
  return (
    <div>StripePaymentSuccessPage</div>
  )
}

export default StripePaymentSuccessPage